<template>
  <div>
    <v-col v-if="hasPackageApproveDesign">
      <v-row>
        <v-btn
          class="btn-confirm mt-4"
          color="green"
          v-if="hasPackageApproveDesign.acceptPackage"
          @click="sendReceivedPackage('ACCEPT')"
          >Accept Received Package</v-btn
        >
      </v-row>
      <v-row class="pt-4">
        <div class="d-flex checkboxDecline">
          <v-checkbox
            v-for="(item, key) in hasPackageApproveDesign.declineReasons"
            :key="key"
            class="pr-2"
            :label="`${item.text}`"
            v-model="packageRejectReason[key]"
            boolean
          />
        </div>
      </v-row>
      <v-row>
        <v-btn
          class="btn-confirm"
          color="red"
          v-if="hasPackageApproveDesign.declinePackage"
          @click="sendReceivedPackage('DECLINE')"
          >Decline Received Package</v-btn
        >
      </v-row>
      <v-row class="pt-4">
        <v-btn
          class="btn-confirm"
          color="red"
          v-if="hasPackageApproveDesign.lateDecline"
          @click="
            sendReceivedPackage(
              'DECLINE',
              hasPackageApproveDesign.lateDeclineReason
            )
          "
          >{{ hasPackageApproveDesign.lateDeclineName }}</v-btn
        >
      </v-row>
      <v-row class="pt-4">
        <v-btn
          class="btn-confirm"
          color="red"
          v-if="hasPackageApproveDesign.secondDecline"
          @click="sendReceivedPackage('DECLINE', hasPackageApproveDesign.secondDeclineReason)"
          >{{ hasPackageApproveDesign.secondDeclineName }}</v-btn
        >
      </v-row>
    </v-col>
    <v-col v-if="hasServiceOpReEvaluate">
      <v-form ref="reEvaluateForm">
        <v-row>
          <v-select
            :name="Math.random()"
            v-model="reEvaluateReason"
            :items="reEvaluateReasonsService"
            item-value="key"
            label="ReEvaluate Reason"
            :item-text="getReason"
            required
            :rules="[
              v =>
                !!v ||
                'Please select the re-evaluate reason for the receipt'
            ]"
          ></v-select>
        </v-row>
        <v-row>
          <v-textarea
            :name="Math.random()"
            v-if="showOtherTextBoxForReEvaluate"
            v-model="customReEvaluation"
            label="Enter ReEvaluate Reason"
            counter
            maxlength="120"
            rows="1"
            full-width
            single-line
            :rules="[
              v =>
                !!v ||
                'Please enter a re-evaluate reason for the receipt'
            ]"
          ></v-textarea>
        </v-row>
        <v-row>
          <v-btn
            width="100%"
            color="primary"
            @click="reEvaluate()"
          >Re-Evaluate</v-btn>
        </v-row>
      </v-form>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFields } from '../../store/helpers'
export default {
  name: "ServiceOpDetails",
  data () {
    return {
      packageRejectReason: [],
      showOtherTextBoxForReEvaluate: false,
      customReEvaluation: "",
      reEvaluateReasonText: "",
    }
  },
  watch: {
    reEvaluateReason(val) {
      if (['productClearlyVisible', 'other'].includes(val)) {
        this.showOtherTextBoxForReEvaluate = true
        return
      }
      this.showOtherTextBoxForReEvaluate = false
      this.reEvaluateReason = val;
    },
  },
  computed: {
    ...mapGetters(['selectedDashboard', 'userToken', 'reEvaluateReasonsService']),
    ...mapFields(['campaign_fk','id','customerToken', 'reEvaluateReason']),
    hasPackageApproveDesign: {
      get () {
        if (
          this.selectedDashboard &&
          this.campaign_fk &&
          this.selectedDashboard.campaigns &&
          this.selectedDashboard.campaigns[this.campaign_fk]
        ) {
          return this.selectedDashboard.campaigns[this.campaign_fk].showPackageApproveDesign ? this.selectedDashboard.campaigns[this.campaign_fk].showPackageApproveDesign : false
        }
        return false
      }
    },
    hasServiceOpReEvaluate: {
      get () {
        if (this.selectedDashboard && this.campaign_fk && this.selectedDashboard.campaigns && this.selectedDashboard.campaigns[this.campaign_fk]) {
          return this.selectedDashboard.campaigns[this.campaign_fk].hasServiceOpReEvaluate
        }
        return false
      }
    },
  },
  methods: {
    ...mapActions(['sendReceivedPackageReceipt', 'sendReEvaluation']),
    sendReceivedPackage(status , rejectReasonType) {
      const payload = {
        dashboard: this.selectedDashboard,
        status,
        data: {
          campaignId: this.campaign_fk,
          receiptToken: this.id,
          customerToken: this.customerToken,
          userToken: this.userToken,
        }
      }
      if (rejectReasonType) {
        payload.data['hardDecline'] = true
        payload.data['rejectReasonType'] = rejectReasonType
      } else if (status === "DECLINE") {
        if (this.packageRejectReason.every(bool => !bool))
          return this.snackAlert({
              message: "Please Select a reject reason "
            });
        const getRejectReason = (boolArr) => {
          console.log(boolArr)
          const rejectReasonsObj = this.hasPackageApproveDesign.declineReasons.filter((_ , index) => {
            return boolArr[index]
          })
        
          return rejectReasonsObj;
        }
        payload.data['rejectReason'] = 'declinePackage'
        payload.data['rejectReasonObj'] = getRejectReason(this.packageRejectReason)
      }
      console.log(payload)
      this.sendReceivedPackageReceipt(payload)
      this.$emit("hideviewer");
    },
    getReason(item) {
      return `[${item.id}] ${item.message}`;
    },
    reEvaluate() {
      const valid = this.$refs.reEvaluateForm.validate();
      if (!valid) return;
      const payload = {
        receiptToken: this.id,
        userToken: this.userToken,
        reClaimText: this.showOtherTextBoxForReEvaluate ? this.customReEvaluation
          : this.reEvaluateReasonText,
        reClaimReason: this.showOtherTextBoxForReEvaluate
          ? this.customReEvaluation
          : this.reEvaluateReason,
        dashboard: this.selectedDashboard
      };
      this.sendReEvaluation(payload);
      this.reEvaluateReason = "";
      this.reEvaluationReason = "";
      this.customReEvaluation = "";
      this.$emit("hideviewer");
    },
  }
}
</script>

<style lang="scss">
.checkboxDecline {
  width: 100%;
  justify-content: center;
}
</style>
